/* eslint-disable no-param-reassign */
import getEsriData from "context/contextFunctions/getEsriData";

export function fixParcelDataPadding(data) {
  // make sure the all codes available
  const values = [data.VILL_CODE, data.HOD_CODE, data.SECT_CODE];
  if (
    values.every((item) => {
      if (`${item}`) return true;
      return false;
    })
  ) {
    data.VILL_CODE = `${data.VILL_CODE}`.padStart(4, "0");
    data.HOD_CODE = `${data.HOD_CODE}`.toString().padStart(3, "0");
    data.SECT_CODE = `${data.SECT_CODE}`.toString().padStart(3, "0");
  }
}

export default async function getParcelsBasedCriteria({
  layerId,
  dispatch,
  data = {},
  token,
  query,
}) {
  fixParcelDataPadding(data);
  query =
    query ||
    `
    VILL_CODE = '${data.VILL_CODE}' AND 
     HOD_CODE = '${data.HOD_CODE}' AND
     SECTOR_CODE = '${data.SECT_CODE}' 
           `;
  const { res, fields, serverFeatureLayerQuery } = await getEsriData({
    token,
    layerId,
    layer: process.env.REACT_APP_DLSParcelsLayer_Table,
    outFields: "HOD_CODE,VILL_CODE,SECTOR_CODE,PARCEL_ID",
    returnDistinctValues: true,
    featureOrMap: "MapServer",
    returnGeometry: false,
    query,
  });

  dispatch({
    type: "INIT",
    payload: {
      parcels: res,
      praParcelsFields: fields,
    },
  });
  return { parcelError: !serverFeatureLayerQuery.fields };
}
